module.exports = __webpack_public_path__ + "img/box-display-1.bd0e9554.png";